"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productionGroup = exports["default"] = void 0;

var _validatorConstants = require("../validator/validatorConstants.js");

var _commons = require("@stktk/commons");

var productionGroup = {
  find: {
    id: _validatorConstants.INTEGER.optional([1]),
    restaurantId: _validatorConstants.INTEGER.required([1])
  },
  create: {
    comment: _validatorConstants.STRING.required([1, 140]),
    restaurantId: _validatorConstants.INTEGER.required([1]),
    rangeFromDate: _validatorConstants.DATE.required([1]),
    rangeToDate: _validatorConstants.DATE.required([1]),
    status: _validatorConstants.ENUM.INTEGER.required([_commons.ProductionGroupStatusEnum.DEFAULT])
  },
  update: {
    id: _validatorConstants.INTEGER.required([1]),
    restaurantId: _validatorConstants.INTEGER.required([1]),
    comment: _validatorConstants.STRING.optional([1, 140]),
    status: _validatorConstants.ENUM.INTEGER.optional(_commons.ProductionGroupStatusEnum.toArray())
  },
  destroy: {
    id: _validatorConstants.INTEGER.required([1]),
    restaurantId: _validatorConstants.INTEGER.required([1])
  }
};
exports.productionGroup = productionGroup;
var _default = productionGroup;
exports["default"] = _default;